module.exports = __webpack_public_path__ + "img/huawei-p30.fda74cc6.png";